import jwt from '../../http/requests/auth/jwt/index.js';
import firebase from 'firebase/app';
import 'firebase/auth';
import router from '@/router';
import httpStatusCode from 'http-status-codes';
import axios from '@/axios';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import {
  ACTION_UPDATE_POPUP,
  ACTION_UPDATE_POPUP_FLAG,
} from '../types/auth-type.js';
import { handleMfaRedirect } from '@/utils/mfa.js';
import loginSuccessHandler from '@/utils/loginSuccessHandler.js';
import { storePlatformSource } from '@/utils/platformMigrationHelper';
Vue.use(VueCookies);

export default {
  loginAttempt({ dispatch }, payload) {
    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation,
    };

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {
      // Change firebase Persistence
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)

        // If success try to login
        .then(function() {
          dispatch('login', newPayload);
        })

        // If error notify
        .catch(function(err) {
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation();

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    } else {
      // Try to login
      dispatch('login', newPayload);
    }
  },
  login({ commit, state, dispatch }, payload) {
    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation();

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });

      return false;
    }

    // Try to sigin
    firebase
      .auth()
      .signInWithEmailAndPassword(
        payload.userDetails.email,
        payload.userDetails.password
      )

      .then(
        result => {
          // Set FLAG username update required for updating username
          let isUsernameUpdateRequired = false;

          // if username is provided and updateUsername FLAG is true
          // set local username update FLAG to true
          // try to update username
          if (payload.updateUsername && payload.userDetails.displayName) {
            isUsernameUpdateRequired = true;

            dispatch('updateUsername', {
              user: result.user,
              username: payload.userDetails.displayName,
              notify: payload.notify,
              isReloadRequired: true,
            });
          }

          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation();

          // if username update is not required
          // just reload the page to get fresh data
          // set new user data in localstorage
          if (!isUsernameUpdateRequired) {
            router.push(router.currentRoute.query.to || '/');
            commit('UPDATE_USER_INFO', result.user.providerData[0], {
              root: true,
            });
          }
        },
        err => {
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation();

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }
      );
  },

  // Google Login
  loginWithGoogle({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      return false;
    }
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true });
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
  },

  // Facebook Login
  loginWithFacebook({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      return false;
    }
    const provider = new firebase.auth.FacebookAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true });
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
  },

  // Twitter Login
  loginWithTwitter({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      return false;
    }
    const provider = new firebase.auth.TwitterAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true });
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
  },

  // Github Login
  loginWithGithub({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
      });
      return false;
    }
    const provider = new firebase.auth.GithubAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true });
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
  },
  registerUser({ dispatch }, payload) {
    // create user using firebase
    firebase
      .auth()
      .createUserWithEmailAndPassword(
        payload.userDetails.email,
        payload.userDetails.password
      )
      .then(
        () => {
          payload.notify({
            title: 'Account Created',
            text: 'You are successfully registered!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
          });

          const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            updateUsername: true,
          };
          dispatch('login', newPayload);
        },
        error => {
          payload.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }
      );
  },
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.displayName,
      })
      .then(() => {
        // If username update is success
        // update in localstorage
        let newUserData = Object.assign({}, payload.user.providerData[0]);
        newUserData.displayName = payload.displayName;
        commit('UPDATE_USER_INFO', newUserData, { root: true });

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || '/');
        }
      })
      .catch(err => {
        payload.notify({
          time: 8800,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
  },

  // JWT
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(
          payload.userDetails.email,
          payload.userDetails.password,
          payload.rememberMe,
          payload.userId ? payload.userId : null,
          payload.secret ? payload.secret : null
        )
        .then(async response => {
          if (payload.secret && payload.userId) {
            localStorage.setItem('userId', payload.userId);
          }

          if (payload.iframe_view) {
            localStorage.setItem('iframe-view', JSON.stringify(payload.iframe_view));
          }

          if (payload.source) {
            storePlatformSource(payload.source);
          }

          // Return true to stop the rest of the callback from executing
          if (handleMfaRedirect(response.data.data, router, payload)) {
            return true;
          }

          if (response.data) {
            await loginSuccessHandler({
              response,
              payload,
              commit,
              router,
            });
            resolve(response);
          } else {
            reject({ message: response.data.message });
          }
        })
        .catch(response => {
          if (
            response &&
            response.message &&
            response.message === 'Request failed with status code 401'
          )
            reject({
              message: 'Email/Password is invalid. Please try again.',
            });
          else if (!response.data) {
            reject({
              message: response,
            });
          } else reject({ message: response.data.message });
        });
    });
  },
  loginJWTV2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .loginV2(
          payload.userDetails.email,
          payload.userDetails.password,
          payload.rememberMe,
        )
        .then(async response => {
          if (payload.secret && payload.userId) {
            localStorage.setItem('userId', payload.userId);
          }

          if (payload.iframe_view) {
            localStorage.setItem('iframe-view', JSON.stringify(payload.iframe_view));
          }

          if (payload.source) {
            storePlatformSource(payload.source);
          }

          // Return true to stop the rest of the callback from executing
          if (handleMfaRedirect(response.data.data, router, payload)) {
            return true;
          }

          if (response.data) {
            await loginSuccessHandler({
              response,
              payload,
              commit,
              router,
            });

            resolve(response);
          } else {
            reject({ message: response.data.message });
          }
        })
        .catch(response => {
          if (
            response &&
            response.message &&
            response.message === 'Request failed with status code 401'
          )
            reject({
              message: 'Email/Password is invalid. Please try again.',
            });
          else if (!response.data) {
            reject({
              message: response,
            });
          } else reject({ message: response.data.message });
        });
    });
  },
  registerUserJWT({ commit }, payload) {
    const { userType } = payload.userDetails;

    return new Promise((resolve, reject) => {
      // Check confirm password
      if (userType !== 'doctorClinic') {
        const { password, confirmPassword } = payload.userDetails;
        if (password !== confirmPassword) {
          reject({ message: 'Password doesn\'t match. Please try again.' });
        }
      }

      if (userType === 'franchise' || userType === 'doctorClinic') {
        jwt
          .registerFranchise(payload.userDetails)
          .then(response => {
            // Redirect User
            router.push(router.currentRoute.query.to || '/');

            // Update data in localStorage
            localStorage.setItem('accessToken', response.data.accessToken);
            commit('UPDATE_USER_INFO', response.data.userData, { root: true });

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        const {
          displayName,
          email,
          password,
          userType,
        } = payload.userDetails;

        jwt
          .registerUser(displayName, email, password, userType)
          .then(response => {
            // Redirect User
            router.push(router.currentRoute.query.to || '/');

            // Update data in localStorage
            localStorage.setItem('accessToken', response.data.accessToken);
            commit('UPDATE_USER_INFO', response.data.userData, { root: true });

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  registerDoctorClinic({ commit }, payload) {
    jwt
      .registerDoctorClinic(payload.userDetails)
      .then(response => {
        // Redirect User
        router.push(router.currentRoute.query.to || '/');

        // Update data in localStorage
        localStorage.setItem('accessToken', response.data.accessToken);
        commit('UPDATE_USER_INFO', response.data.userData, { root: true });

        Promise.resolve(response);
      })
      .catch(error => {
        Promise.reject(error);
      });
  },
  fetchAccessToken() {
    return new Promise(resolve => {
      jwt.refreshToken().then(response => {
        resolve(response);
      });
    });
  },
  resetPassword(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .resetPassword(payload.userDetails.password, payload.userDetails.token)
        .then(response => {
          if (response.status == httpStatusCode.OK) {
            resolve(response);
          } else {
            reject({ message: response.data.message });
          }
        })
        .catch(response => {
          reject({ message: response.data.message });
        });
    });
  },
  forgotPwd(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .forgotPasswordAdmin(payload.userDetail.email)
        .then(response => {
          if (response.data) {
            resolve(response);
          } else {
            reject({ message: response.data.message });
          }
        })
        .catch(response => {
          reject({ message: response.data.message });
        });
    });
  },
  changeUserPassword(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .changePassword(
          payload.userDetails.currentPassword,
          payload.userDetails.newPassword
        )
        .then(response => {
          // If there's user data in response
          if (response.status == httpStatusCode.OK) {
            resolve(response);
          } else {
            reject({ message: response.data.message });
          }
        })
        .catch(err => {
          reject({ message: err.data.message });
        });
    });
  },
  checkTokenExpiry(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .checkTokenExpiry(payload.token)
        .then(response => {
          // If there's user data in response
          if (response.status == httpStatusCode.OK) {
            resolve(response);
          } else {
            reject({ message: response.data.message });
          }
        })
        .catch(({ response }) => {
          reject({ message: response.data.message });
        });
    });
  },

  verifyAccount(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/user/verifyAccount', payload)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err.response);
        });
    });
  },

  checkLoggedIn(_context, payload) {
    if (payload.token) {
      if (payload.userType === 'superAdmin') {
        return '/admin/dashboard';
      }
      if (payload.userType === 'franchise') {
        router.push('/franchise/dashboard');
      }
      if (payload.userType === 'clinic') {
        router.push('/clinic/dashboard');
      }
      if (payload.userType === 'doctor') {
        router.push('/doctor/dashboard');
      }
      if (payload.userType === 'nurse') {
        router.push('/nurse/dashboard');
      }
      if (payload.userType === 'admin') {
        router.push('/sub-admin/dashboard');
      }
    }
  },
  [ACTION_UPDATE_POPUP]({ commit }, show) {
    commit('UPDATE_POPUP', show);
  },
  [ACTION_UPDATE_POPUP_FLAG]({ commit }, show) {
    commit('UPDATE_POPUP_FLAG', show);
  },
  verifyMFA(_context, data) {
    return axios.post('/api/v2/admins/auth/mfa/verify', data);
  },
  requestNewMFA(_context, data) {
    return axios.post('/api/v2/admins/auth/mfa/send', data);
  },
};
